import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Avatar } from '../components/Avatar'
import { useApp } from '../store/AppContext'
import { localISODate } from '../lib/date'
import { youthVisibleEvents } from '../lib/youthCalendar'

export function YouthCalendar() {
  const { events, allUsers, currentUser, addEvent } = useApp()
  const today = localISODate()
  const [showAdd, setShowAdd] = useState(false)
  const [title, setTitle] = useState('')
  const [date, setDate] = useState(today)
  const [startTime, setStartTime] = useState('16:00')
  const [endTime, setEndTime] = useState('17:00')

  const upcoming = youthVisibleEvents(events, allUsers, currentUser.id)
    .filter((event) => event.date >= today)
    .slice()
    .sort((a, b) => `${a.date}${a.startTime}`.localeCompare(`${b.date}${b.startTime}`))
    .slice(0, 20)

  const addMyEvent = () => {
    if (!title.trim() || !date || !startTime || !endTime || endTime <= startTime) return
    addEvent({
      id: `youth-event-${Date.now()}`,
      title: title.trim(),
      type: 'appointment',
      date,
      startTime,
      endTime,
      assignees: [{ userId: currentUser.id, status: 'accepted' }],
      createdByUserId: currentUser.id,
      notes: 'Added by the child from Youth Calendar.',
    })
    setTitle('')
    setShowAdd(false)
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-violet-100 to-sky-50 pb-28">
      <div className="flex items-center gap-3 px-4 pt-5">
        <Link to="/today" className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white text-xl font-black shadow-card">←</Link>
        <div className="min-w-0 flex-1"><p className="text-sm font-extrabold text-violet-600">My Calendar</p><h1 className="text-3xl font-black text-slate-900">What’s coming up 📅</h1></div>
      </div>

      <div className="px-4 pt-4">
        <button onClick={() => setShowAdd((value) => !value)} className="w-full rounded-3xl bg-violet-600 py-4 text-lg font-black text-white shadow-card">
          {showAdd ? 'Close' : '+ Add something to my calendar'}
        </button>
      </div>

      {showAdd && (
        <div className="mx-4 mt-3 rounded-3xl bg-white p-5 shadow-card">
          <p className="text-lg font-black text-slate-900">Add my event ⭐</p>
          <input className="input mt-3" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="What am I doing?" />
          <input className="input mt-2" type="date" min={today} value={date} onChange={(e) => setDate(e.target.value)} />
          <div className="mt-2 grid grid-cols-2 gap-2">
            <label className="text-xs font-bold text-slate-500">Starts<input className="input mt-1" type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} /></label>
            <label className="text-xs font-bold text-slate-500">Ends<input className="input mt-1" type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} /></label>
          </div>
          <button onClick={addMyEvent} className="mt-4 w-full rounded-2xl bg-emerald-500 py-3 text-base font-black text-white">Add to my calendar</button>
        </div>
      )}

      <div className="flex flex-col gap-3 px-4 py-5">
        {upcoming.length === 0 && <div className="rounded-3xl bg-white p-6 text-center font-bold text-slate-500 shadow-card">Nothing is planned yet.</div>}
        {upcoming.map((event) => {
          const worker = event.assignees.map((a) => allUsers.find((u) => u.id === a.userId)).find((u) => u?.role === 'support_worker')
          const creator = allUsers.find((user) => user.id === event.createdByUserId)
          const isMyEvent = event.createdByUserId === currentUser.id
          const dateLabel = new Date(`${event.date}T00:00:00`).toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'short' })
          return (
            <article key={event.id} className="rounded-3xl bg-white p-5 shadow-card">
              <div className="flex gap-4">
                <span className="text-4xl">{event.type === 'shift' ? '👤' : isMyEvent ? '⭐' : '🩺'}</span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-black text-violet-600">{dateLabel}</p>
                  <h2 className="mt-1 text-xl font-black text-slate-900">{event.title}</h2>
                  <p className="mt-1 text-base font-bold text-slate-500">{event.startTime}–{event.endTime}</p>
                  {worker && <div className="mt-3 flex items-center gap-2 rounded-2xl bg-sky-50 p-3"><Avatar user={worker} size={38} /><div><p className="text-xs font-bold text-sky-700">Supporting me</p><p className="font-black text-slate-900">{worker.name}</p></div></div>}
                  {!worker && !isMyEvent && creator?.role === 'allied_health' && <p className="mt-2 rounded-xl bg-emerald-50 px-3 py-2 text-sm font-bold text-emerald-700">With {creator.name}</p>}
                  {isMyEvent && <p className="mt-2 text-xs font-bold text-amber-600">I added this event</p>}
                </div>
              </div>
            </article>
          )
        })}
      </div>
    </div>
  )
}

